// IE 2026 09 28 / ODOO-342342 (п.14, пилот якорей на Demo — ie-demo7 #49365): «Save as data test» — страница виджета уходит в запрос save_as_test (page).
// Бэк (processing_tests.create_test_from_widget) берёт doc.page теста только из request.page; фронт её не передавал, тест TEST-DATA писался с page = '',
// и «Open in demo» (guide.plan_from_test) открывал стол без перехода на страницу.
// IE 2026 09 29 / ODOO-342342 (ревью ie-dm7 п.5): входы — только пункт меню бэка widget_RECORD_BASE.set_menu (common_modules/widgets.py): меню грида
// отчёта / списка и форма записи. Оба виджета открыты на странице (store.widget_open: page = активная страница стола) — шлём свою page.
// Формы ячейки / строки (widget_ROW) у save_as_test нет — ни пункта меню, ни метода, поэтому подъём по parentWIDGET убран (мёртвый код).
// Виджет вне страниц (хранилище workspace-store / page-store) — page не шлётся: бэк при показе найдёт страницу по виджету (guide.test_page, п.15).
const STORE_PAGE = 'page-store', STORE_WS = 'workspace-store'

export function saveAsTest_page(W) {
    const p = String(W?.page || '')
    return p && p !== STORE_PAGE && W.workspace !== STORE_WS ? p : ''
}

// поля запроса executeWidgetMethod: только для save_as_test — { page }
export function saveAsTest_params(W, action) {
    if (!action || action.method !== 'save_as_test') return {}
    const page = saveAsTest_page(W)
    return page ? { page } : {}
}

export default { saveAsTest_page, saveAsTest_params }
